import { withMemberContext } from '@/config/site'
import request from '@/utils/request'

export const fetchNotificationList = async(payload = {}) => {
  const response = await request('/page/notification/index', {
    data: withMemberContext({
      page: 1,
      page_size: 15,
      ...payload
    })
  })

  const data = response.data || {}

  return {
    list: Array.isArray(data.list) ? data.list : [],
    total: Number(data.total) || 0,
    page: Number(data.page) || 1,
    page_size: Number(data.page_size) || 15
  }
}

export const fetchNotificationDetail = async(id) => {
  const response = await request('/page/notification/detail', {
    data: withMemberContext({ id })
  })

  return response.data || {}
}

export const fetchNotificationUnreadCount = async() => {
  const response = await request('/page/notification/unread-count', {
    data: withMemberContext({})
  })

  const data = response.data || {}
  return Number(data.unread_count || data.count || 0)
}

export const fetchNotificationHasNew = async(lastId = 0) => {
  const response = await request('/page/notification/has-new', {
    data: withMemberContext({
      last_id: Number(lastId) || 0
    })
  })

  const data = response.data || {}
  return {
    has_new: Boolean(data.has_new),
    unread_count: Number(data.unread_count || 0),
    latest_id: Number(data.latest_id || 0)
  }
}

export const markNotificationRead = async(ids = null) => {
  const payload = {}

  if (Array.isArray(ids)) {
    payload.ids = ids
  } else if (ids) {
    payload.ids = [ids]
  }

  return request('/page/notification/mark-read', {
    data: withMemberContext(payload)
  })
}

const normalizePagedResult = (response, payload = {}, defaultPageSize = 15) => {
  const data = response.data || {}

  if (Array.isArray(data)) {
    return {
      list: data,
      total: data.length,
      page: Number(payload.page) || 1,
      page_size: Number(payload.page_size) || data.length || defaultPageSize
    }
  }

  return {
    list: Array.isArray(data.list) ? data.list : [],
    total: Number(data.total) || 0,
    page: Number(data.page) || Number(payload.page) || 1,
    page_size: Number(data.page_size) || Number(payload.page_size) || defaultPageSize
  }
}

export const fetchNotificationRecipientOptions = async(payload = {}) => {
  const response = await request('/page/notification/recipient-options', {
    data: withMemberContext({
      keyword: '',
      page: 1,
      page_size: 100,
      ...payload
    })
  })

  const data = response.data || {}
  if (Array.isArray(data)) return data
  if (Array.isArray(data.list)) return data.list
  if (Array.isArray(data.options)) return data.options
  return []
}

export const sendStudentNotification = async(payload = {}) => {
  const recipientIds = payload.recipient_ids || payload.recipient_member_ids || payload.member_ids || payload.target_ids || []

  const response = await request('/page/notification/send', {
    data: withMemberContext({
      title: payload.title || '',
      content: payload.content || '',
      recipient_ids: recipientIds,
      recipient_member_ids: recipientIds,
      member_ids: recipientIds,
      target_ids: recipientIds,
      course_id: Number(payload.course_id || 0),
      ...payload
    })
  })

  return response.data || {}
}

export const fetchSentNotificationList = async(payload = {}) => {
  const response = await request('/page/notification/sent-index', {
    data: withMemberContext({
      page: 1,
      page_size: 15,
      ...payload
    })
  })

  return normalizePagedResult(response, payload)
}

export const fetchSentNotificationStats = async(notificationId) => {
  const response = await request('/page/notification/sent-stats', {
    data: withMemberContext({
      notification_id: notificationId,
      id: notificationId
    })
  })

  return response.data || {}
}

export const fetchSentNotificationRecipients = async(notificationId, payload = {}) => {
  const response = await request('/page/notification/sent-recipients', {
    data: withMemberContext({
      notification_id: notificationId,
      id: notificationId,
      page: 1,
      page_size: 20,
      ...payload
    })
  })

  return normalizePagedResult(response, payload, 20)
}
